import React, { useState } from 'react';
import classnames from 'classnames';
import { IconLikeDown, IconLikeUp } from '../Icons';
import NegativeFeedbackModal from './NegativeFeedbackModal';
import { OpenSuccessToast } from '../Toast/Toast';
import './Feedback.scss';

interface FeedbackProps {
  smallMargin?: boolean;
  params: {
    type: 'product' | 'tutorial' | 'library';
    title: string;
    slug: string;
    comment?: string; // Only if negative
  };
}

export default function Feedback({ smallMargin, params }: FeedbackProps): React.ReactElement {
  const [isModalOpen, setModalOpen] = useState(false);
  const [feedbackDisabled, setFeedbackDisabled] = useState(false);
  const [status, setStatus] = useState<string>('');

  const sendFeedback = async (feedback, comment = '') => {
    await fetch('https://hooks.zapier.com/hooks/catch/14856173/23pisq2/', {
      method: 'POST',
      body: JSON.stringify({
        feedback,
        comment,
        environment: process.env.GATSBY_HF_ENV,
        date: new Date().toISOString(),
        ...params,
      }),
    });
    OpenSuccessToast('Thank you for your feedback!');
    setFeedbackDisabled(true);
  };

  return (
    <div className={classnames('feedback', { 'feedback__small-margin': smallMargin })}>
      <h4>Was this article helpful?</h4>
      <div className="feedback__buttons">
        <button
          className={classnames({ positiveCheck: status === 'positive' })}
          onClick={() => {
            if (status === '') {
              sendFeedback('positive');
              setStatus('positive');
            }
          }}
          disabled={feedbackDisabled}
        >
          <IconLikeUp />
        </button>
        <button
          className={classnames({ negativeCheck: status === 'negative' })}
          onClick={() => status === '' && setModalOpen(true)}
          disabled={feedbackDisabled}
        >
          <IconLikeDown />
        </button>
      </div>
      <NegativeFeedbackModal
        isOpen={isModalOpen}
        onClose={() => {
          sendFeedback('negative');
          setStatus('negative');
          setModalOpen(false);
        }}
        onSubmit={(comment) => {
          sendFeedback('negative', comment);
          setStatus('negative');
          setModalOpen(false);
        }}
      />
    </div>
  );
}
